var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 60
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-10h80v80H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4BFD5",
    fillRule: "nonzero",
    d: "M36.643 0v21.818H19v5.455H0V60h76V27.273H57v-5.455H39.357V0h-2.714zM21.714 24.545h32.572v32.728H21.714V24.545zM2.714 30H19v27.273H2.714V30zM57 30h16.286v27.273H57V30z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B4BFD5",
    strokeWidth: 2,
    d: "M38 2h12l-3.904 4.368L50 11H38z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B4BFD5",
    strokeWidth: 3,
    d: "M32 58h12V42H32z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NiIgaGVpZ2h0PSI2MCIgdmlld0JveD0iMCAwIDc2IDYwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTS0yLTEwaDgwdjgwSC0yeiIvPgogICAgICAgIDxnPgogICAgICAgICAgICA8cGF0aCBmaWxsPSIjQjRCRkQ1IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0zNi42NDMgMHYyMS44MThIMTl2NS40NTVIMFY2MGg3NlYyNy4yNzNINTd2LTUuNDU1SDM5LjM1N1YwaC0yLjcxNHpNMjEuNzE0IDI0LjU0NWgzMi41NzJ2MzIuNzI4SDIxLjcxNFYyNC41NDV6TTIuNzE0IDMwSDE5djI3LjI3M0gyLjcxNFYzMHpNNTcgMzBoMTYuMjg2djI3LjI3M0g1N1YzMHoiLz4KICAgICAgICAgICAgPHBhdGggc3Ryb2tlPSIjQjRCRkQ1IiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0zOCAyaDEybC0zLjkwNCA0LjM2OEw1MCAxMUgzOHoiLz4KICAgICAgICAgICAgPHBhdGggc3Ryb2tlPSIjQjRCRkQ1IiBzdHJva2Utd2lkdGg9IjMiIGQ9Ik0zMiA1OGgxMlY0MkgzMnoiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgOrganizations as ReactComponent };